<label [class.full-screen]="isFullScreen">
    <span class="label">{{ 'lta.formula' | translate }}</span>
    <div
            #area
            class="area"
    >
        <ng-container *ngFor="let element of (elements$ | async);">
            <ng-container [ngSwitch]="element.type">
                <ng-container
                        *ngSwitchCase="0"
                        [ngTemplateOutletContext]="{ $implicit: element }"
                        [ngTemplateOutlet]="pointer"
                ></ng-container>
                <ng-container
                        *ngSwitchCase="1"
                        [ngTemplateOutletContext]="{ $implicit: element }"
                        [ngTemplateOutlet]="sign"
                ></ng-container>
                <ng-container
                        *ngSwitchCase="2"
                        [ngTemplateOutletContext]="{ $implicit: element }"
                        [ngTemplateOutlet]="object"
                ></ng-container>
            </ng-container>
        </ng-container>
    </div>
    <span
            *ngIf="error"
            class="hint error under-input-signs"
    >{{ error | translate }}</span>
    <div class="bottom">
        <div>
            <ng-container
                    *ngIf="!isFullScreen"
                    [ngTemplateOutlet]="fullScreen"
            ></ng-container>
        </div>
        <ng-container
                [ngTemplateOutlet]="info"
        ></ng-container>
    </div>
</label>


<ng-template
        #pointer
        let-element
>
	<span class="element pointer">
		<span
                #input
                (input)="setValue($event)"
                [hidden]="element.hidden"
                [ngClass]="{error: element.error, selected: element.selected}"
                [textContent]="value"
                class="input"
                contenteditable
        ></span>
	</span>
</ng-template>

<ng-template
        #sign
        let-element
>
    <span
            [ngClass]="{error: element.error, selected: element.selected}"
            class="element sign"
    >{{ element.value }}</span>
</ng-template>

<ng-template
        #object
        let-element
>
    <span
            [ngClass]="{error: element.error, selected: element.selected}"
            class="element object text-ellipsis"
    >{{ reduceObjectValue(element.value) }}</span>
</ng-template>

<ng-template #fullScreen>
    <span
            (click)="onFullScreen.emit()"
            class="title info under-input-signs"
    >{{ 'lta-object.fullScreen' | translate }}</span>
</ng-template>


<ng-template #info>
    <lta-info-popup
            [popupGap]="24"
            [position]="'topLeft'"
            [width]="'410px'"
    >
        <span class="title">{{ 'math.mathOperations' | translate }}</span>
        <div class="modal">
            <div>{{ 'math.mathOperations' | translate }}:</div>
            <div><span class="operator">[ <span>+</span> ]</span> {{ 'math.addition' | translate }}</div>
            <div><span class="operator">[ <span>–</span> ]</span> {{ 'math.subtraction' | translate }}</div>
            <div><span class="operator">[ <span>*</span> ]</span> {{ 'math.multiplication' | translate }}</div>
            <div><span class="operator">[ <span>/</span> ]</span> {{ 'math.division' | translate }}</div>
            <div><span class="operator">[ <span>></span> ]</span> {{ 'math.greaterThan' | translate }}</div>
            <div><span class="operator">[ <span><</span> ]</span> {{ 'math.lessThan' | translate }}</div>
            <div><span class="operator">[ <span>=</span> ]</span> {{ 'math.equal' | translate }}</div>
            <div><span class="operator">[ <span>^</span> ]</span> {{ 'math.power' | translate }}</div>
            <div><span class="operator">[ <span>!</span> ]</span> {{ 'math.not' | translate }}</div>
            <div><span class="operator">[ <span>>=</span> ]</span> {{ 'math.moreOrEqual' | translate }}</div>
            <div><span class="operator">[ <span><=</span> ]</span> {{ 'math.lessOrEqual' | translate }}</div>
            <div><span class="operator">[ <span>!=</span> ]</span> {{ 'math.notEqual' | translate }}</div>
            <div><span class="operator">[ <span>{{'{.}'}}</span> ]</span> {{ 'math.integration' | translate }}</div>
            <div><span class="operator">[ <span>ЕСЛИ</span> ]</span> {{ 'math.operator' | translate }} ЕСЛИ</div>
            <div><span class="operator"></span> (<{{ 'math.expression' | translate }}>;</div>
            <div><span class="operator"></span> <{{'math.valueIfExpression' | translate}} {{ 'math.true' | translate}}>;</div>
            <div><span class="operator"></span> <{{'math.valueIfExpression' | translate}} {{ 'math.false' | translate }}>)</div>
            <div><span class="operator">[ <span>ЕСЛИМН</span> ]</span> {{ 'math.operator' | translate }} ЕСЛИМН</div>
            <div><span class="operator"></span> (<{{ 'math.expression' | translate }}<i>1</i>>;</div>
            <div><span class="operator"></span> <{{'math.valueIfExpression' | translate}}<i>1</i> {{ 'math.true' | translate }}>;</div>
            <div><span class="operator"></span> <{{'math.valueIfExpression' | translate}}<i>1</i> {{ 'math.false' | translate }}>;</div>
            <div><span class="operator"></span> ...</div>
            <div><span class="operator"></span> <{{ 'math.expression' | translate }}<i>n</i>>;</div>
            <div><span class="operator"></span> <{{'math.valueIfExpression' | translate}}<i>n</i> {{ 'math.true' | translate }}>;</div>
            <div><span class="operator"></span> <{{'math.valueIfExpression' | translate}}<i>n</i> {{ 'math.false' | translate }}>)</div>

        </div>
    </lta-info-popup>
</ng-template>
